import { TipoOsParamModel } from './../model/tipo-os-param.model';
import { OrdemServicoIn } from './../model/ordem-servico-in.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {constants} from '../app-constants';
import {
  PaginacaoParamModel,
  BuscarOrdemServicoIn,
  AtivoParamModel,
  TipoOsAtivoParamModel,
  EnderecoModel
} from '../model';
import { timeout } from 'rxjs/operators';
import {QrCodeIn} from '../model/qr-code-in';
import {BuscarAmbienteIn} from "../model/buscar-ambiente-in.model";
import {AnexoIn} from "../model/anexo-in";

@Injectable({
  providedIn: 'root'
})
export class OrdemServicoService {

  private httpOptions = constants.httpDefaultOptions;

  private pathOSWS = `/WS/rest/PortalCliente`;

  constructor( private http: HttpClient) {   }

  adicionar(frm: OrdemServicoIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/CriarOs/v1`, JSON.stringify(frm), this.httpOptions).pipe(timeout(60000));
  }

  findByCliente(): Observable<any> {
    return this.http.get<any>(`${this.pathOSWS}/BuscarCliente/v1`).pipe(timeout(60000));
  }

  listarAtivos(ativoIn: AtivoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarAtivo/v1`, JSON.stringify(ativoIn), this.httpOptions).pipe(timeout(60000));
  }

  listarOsS(buscarOrdemServicoIn: BuscarOrdemServicoIn): Observable<any> {
      return this.http.post<any>(`${this.pathOSWS}/BuscarOS/v1`, JSON.stringify(buscarOrdemServicoIn), this.httpOptions);
  }

  imprimirOsS(buscarOrdemServicoIn: BuscarOrdemServicoIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/ImprimirOS/v1`, JSON.stringify(buscarOrdemServicoIn), this.httpOptions);
  }

  listarTipoOSs(tipoOsParam: TipoOsParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarTipoOS/v1`, JSON.stringify(tipoOsParam), this.httpOptions).pipe(timeout(60000));
  }

  listarTipoOSAtivo(parametro: TipoOsAtivoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarTipoOSAtivo/v1`, JSON.stringify(parametro), this.httpOptions).pipe(timeout(60000));
  }

  listarEnderecos(paginacaoParam: PaginacaoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarEndereco/v1`, JSON.stringify(paginacaoParam), this.httpOptions).pipe(timeout(60000));
  }

  listarAmbientes(buscarAmbienteIn: BuscarAmbienteIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarAmbiente/v1`, JSON.stringify(buscarAmbienteIn), this.httpOptions).pipe(timeout(15000));
  }
  listarEquipes(paginacaoParam: PaginacaoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarEquipe/v1`, JSON.stringify(paginacaoParam), this.httpOptions).pipe(timeout(60000));
  }

  listarMotivo(paginacaoParam: PaginacaoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarMotivo/v1`, JSON.stringify(paginacaoParam), this.httpOptions).pipe(timeout(60000));
  }

  listarStatus(paginacaoParam: PaginacaoParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarStatus/v1`, JSON.stringify(paginacaoParam), this.httpOptions).pipe(timeout(60000));
  }

  listarTiposOSFiltro (parametro: TipoOsParamModel): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarTipoOSFiltro/v1`, JSON.stringify(parametro), this.httpOptions).pipe(timeout(60000));
  }

  buscarAtivoQRCode (QRCode: QrCodeIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarAtivoQRCode/v1`, JSON.stringify(QRCode), this.httpOptions).pipe(timeout(150000));
  }

  buscarAtivoQRCodeNovaOS (QRCode: QrCodeIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/BuscarAtivoQRCodeNovaOS/v1`, JSON.stringify(QRCode), this.httpOptions)
      .pipe(timeout(150000));
  }

  salvarAnexo (anexoIn: AnexoIn): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/AnexarArquivo/v1`, JSON.stringify(anexoIn), this.httpOptions)
      .pipe(timeout(150000));
  }
}

